// Vap House: agrega/quita solo el "Decant de regalo" según el subtotal pagado.
// Decide leyendo /cart.js (nunca el DOM a medio actualizar) y avisa a Horizon con el mismo
// CartLinesUpdateEvent que usa product-form.js, para que el cajón y el contador se redibujen.
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

let ocupado = false, pendiente = false, propio = false;

function config() {
  const el = document.getElementById('vh-regalo-cfg');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
}

async function reconciliar() {
  const cfg = config();
  if (!cfg || !cfg.variante) return;
  if (ocupado) { pendiente = true; return; }
  ocupado = true;
  try {
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    const regalo = cart.items.filter((i) => i.variant_id === cfg.variante);
    const fuera = [cfg.variante, ...(cfg.excluir || [])];   // el regalo y el envío protegido no cuentan
    const pagado = cart.items.filter((i) => !fuera.includes(i.variant_id)).reduce((s, i) => s + i.final_line_price, 0);
    const corresponde = !!cfg.on && pagado >= cfg.umbral;
    let url, cuerpo, cantidad;
    // huérfano: sin perfumes, el envío protegido (u otro auxiliar) no puede quedar solo cobrando
    const huerfano = pagado === 0 ? cart.items.find((i) => (cfg.excluir || []).includes(i.variant_id)) : null;
    if (huerfano) { url = '/cart/change.js'; cuerpo = { id: huerfano.key, quantity: 0 }; cantidad = 0; pendiente = true; }
    else if (corresponde && regalo.length === 0) { url = '/cart/add.js'; cuerpo = { id: cfg.variante, quantity: 1 }; cantidad = 1; }
    else if (corresponde && regalo[0].quantity !== 1) { url = '/cart/change.js'; cuerpo = { id: regalo[0].key, quantity: 1 }; cantidad = 1; }
    else if (!corresponde && regalo.length) { url = '/cart/change.js'; cuerpo = { id: regalo[0].key, quantity: 0 }; cantidad = 0; }
    else return;

    const ids = [...new Set([...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean))];
    const diferido = CartLinesUpdateEvent.createPromise();
    propio = true;
    document.body.dispatchEvent(new CartLinesUpdateEvent({
      action: 'update', context: 'cart',
      lines: [{ merchandiseId: String(cfg.variante), quantity: cantidad }],
      promise: diferido.promise,
    }));
    propio = false;
    try {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...cuerpo, sections: ids.join(',') }) });
      const res = await r.json();
      const nuevo = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      diferido.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(nuevo),
        detail: { items: nuevo.items, source: 'vh-carrito-regalo', sourceId: 'vh-regalo', itemCount: nuevo.item_count,
                  sections: res.sections, didError: !!res.status },
      });
    } catch (err) { console.error('vh-regalo', err); diferido.reject(err); }
  } finally {
    ocupado = false;
    if (pendiente) { pendiente = false; reconciliar(); }
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (e) => {
  if (propio) return;                        // el evento que acabo de disparar yo
  (e.promise || Promise.resolve()).then(() => reconciliar(), () => reconciliar());
});
reconciliar();
